import React from 'react';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { Absolute, BodyText } from '../../ui';
import { Z_FG } from '../../ui/utilities/zIndex';

type ClientChatEntryPointProps = {
  Icon: React.FunctionComponent<{ color?: string; width?: number; height?: number }>;
  selected: boolean;
  inboxUnreadCounter: number;
};

export const ClientChatEntryPoint: React.FCWithChildren<ClientChatEntryPointProps> = ({
  Icon,
  selected,
  inboxUnreadCounter,
}) => (
  <Box
    height={20}
    width={20}
    justifyContent="center"
    alignItems="center"
  >
    {(inboxUnreadCounter > 0) && (
      <Absolute
        left={-8}
        top={-5}
        zIndex={Z_FG}
        color={BrandColor.Red}
        minWidth={16}
        minHeight={16}
        borderRadius={50}
        justifyContent="center"
        alignItems="center"
      >
        <BodyText
          color={BrandColor.WhiteWash}
          appearance="smaller"
          weight="bold"
          testID="unread-chats-counter"
        >
          {(inboxUnreadCounter > 9) ? '9+' : inboxUnreadCounter}
        </BodyText>
      </Absolute>
    )}
    <Icon color={selected ? BrandColor.BackInBlack : BrandColor.Ash} />
  </Box>
);
